<template>
	<div class="videoList">
		<div v-for="(video, i) in videoList" :key="`${ i } + ${ video.id }`" :id="video.id" :class="`video ${ video.VideoResource }`">
			<h3>{{ video.Name }}</h3>

			<iframe 
				v-if="video.VideoResource == 'SeattleChannel'"
				:src="`http://seattlechannel.org/embedvideoplayer?videoid=${ video.VideoId }`" 
				frameborder="0" 
				scrolling="no"
				class="embedVideo seattleChannel">
			</iframe>

			<iframe 
				v-if="video.VideoResource == 'Vimeo'"
				:src="`https://player.vimeo.com/video/${ video.VideoId }?title=0&byline=0&portrait=0`" 
				frameborder="0" 
				webkitallowfullscreen 
				mozallowfullscreen 
				allowfullscreen 
				class="embedVideo vimeo">
			</iframe>

			<span class="video-responsive " v-if="video.VideoResource == 'YouTube'">
				<iframe 
					:src="`https://www.youtube.com/embed/${ video.VideoId }?rel=0&amp;showinfo=0`" 
					frameborder="0"
					gesture="media" 
					allow="encrypted-media" 
					allowfullscreen 
					class="embedVideo youTube">
				</iframe>
			</span>
		</div>
	</div>
</template>
 
<script>
	export default {
		name: 'external-video',
		props: {
			'video' : Object,
		},
		computed: {
			videoList() {
				return (Array.isArray(this.video)) ? this.video : [this.video]
			}
		}
	};
</script> 